// extracted by mini-css-extract-plugin
export var button = "_90-7";
export var buttonRow = "_90-6";
export var fadeIn = "_90-1";
export var gradient = "_90-0";
export var panel = "_90-2";
export var panelIn = "_90-3";
export var subtitle = "_90-5";
export var title = "_90-4";